var _class, _descriptor, _CategoryDropMoreCollection;
function _initializerDefineProperty(e, i, r, l) {
  r && Object.defineProperty(e, i, {
    enumerable: r.enumerable,
    configurable: r.configurable,
    writable: r.writable,
    value: r.initializer ? r.initializer.call(l) : void 0
  });
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _applyDecoratedDescriptor(i, e, r, n, l) {
  var a = {};
  return Object.keys(n).forEach(function (i) {
    a[i] = n[i];
  }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) {
    return n(i, e, r) || r;
  }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a;
}
function _initializerWarningHelper(r, e) {
  throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform.");
}
import Component from "@glimmer/component";
import { hash } from "@ember/helper";
import { LinkTo } from "@ember/routing";
import { inject as service } from "@ember/service";
import icon from "discourse-common/helpers/d-icon";
import i18n from "discourse-common/helpers/i18n";
import { ALL_CATEGORIES_ID, NO_CATEGORIES_ID } from "select-kit/components/category-drop";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
let CategoryDropMoreCollection = (_class = (_CategoryDropMoreCollection = class CategoryDropMoreCollection extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "site", _descriptor, this);
    _defineProperty(this, "tagName", "");
  }
  get moreCount() {
    if (!this.args.selectKit.totalCount) {
      return 0;
    }
    const currentCount1 = this.args.collection.content.filter(category1 => category1.id !== NO_CATEGORIES_ID && category1.id !== ALL_CATEGORIES_ID).length;
    return this.args.selectKit.totalCount - currentCount1;
  }
  get slugPath() {
    return this.args.selectKit.options.parentCategory.path.substring("/c/".length);
  }
}, setComponentTemplate(createTemplateFactory(
/*
  
    {{#if this.moreCount}}
      <div class="category-drop-footer">
        <span>
          {{i18n "categories.plus_more_count" (hash count=this.moreCount)}}
        </span>

        {{#if @selectKit.options.parentCategory}}
          <LinkTo @route="discovery.subcategories" @model={{this.slugPath}}>
            {{i18n "categories.view_all"}}
            {{icon "external-link-alt"}}
          </LinkTo>
        {{else}}
          <LinkTo @route="discovery.categories">
            {{i18n "categories.view_all"}}
            {{icon "external-link-alt"}}
          </LinkTo>
        {{/if}}
      </div>
    {{/if}}
  
*/
{
  "id": "wb8Q9PhV",
  "block": "[[[1,\"\\n\"],[41,[30,0,[\"moreCount\"]],[[[1,\"      \"],[10,0],[14,0,\"category-drop-footer\"],[12],[1,\"\\n        \"],[10,1],[12],[1,\"\\n          \"],[1,[28,[32,0],[\"categories.plus_more_count\",[28,[32,1],null,[[\"count\"],[[30,0,[\"moreCount\"]]]]]],null]],[1,\"\\n        \"],[13],[1,\"\\n\\n\"],[41,[30,1,[\"options\",\"parentCategory\"]],[[[1,\"          \"],[8,[32,2],null,[[\"@route\",\"@model\"],[\"discovery.subcategories\",[30,0,[\"slugPath\"]]]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[32,0],[\"categories.view_all\"],null]],[1,\"\\n            \"],[1,[28,[32,3],[\"external-link-alt\"],null]],[1,\"\\n          \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"          \"],[8,[32,2],null,[[\"@route\"],[\"discovery.categories\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[32,0],[\"categories.view_all\"],null]],[1,\"\\n            \"],[1,[28,[32,3],[\"external-link-alt\"],null]],[1,\"\\n          \"]],[]]]]],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"]],[\"@selectKit\"],false,[\"if\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/category-drop-more-collection.js",
  "scope": () => [i18n, hash, LinkTo, icon],
  "isStrictMode": true
}), _CategoryDropMoreCollection), _CategoryDropMoreCollection), _descriptor = _applyDecoratedDescriptor(_class.prototype, "site", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { CategoryDropMoreCollection as default };